<mat-card appearance="outlined" class="playbook-card">
  <div class="row mat-headline-6 p-10">
    <div class="col-md-8">
      <mat-card-title>
        {{title}}
      </mat-card-title>
    </div>
    <div class="col-md-4">
      <div class="btn-group float-right mt-2" role="group">
        <button type="button" (click)="toggle()" mat-button>
          <i class="fa fa-code f-s-20"></i>
        </button>
      </div>
    </div>
  </div>
  <mat-card-subtitle>
    <!-- Put code for example, component and urls -->
    <ng-content>
    </ng-content>
  </mat-card-subtitle>
  <mat-card-content>

    @if (showCode) {
      <div>
        <mat-tab-group (selectedTabChange)="onTabChange($event)">
          <mat-tab label="HTML">
            <pre>
              <button type="button" mat-button class="copy" (click)="copyCode(htmlCode)">
                <i  class="fa fa-copy"></i>
              </button>
              <cpq-scripting-codemirror #editor [script]="htmlScript" [languageType]="htmlLanguageType" [lineNumbers]="false" [styleActiveLine]="true" [disabled]="false"></cpq-scripting-codemirror>
            </pre>
          </mat-tab>
          <mat-tab label="TS">
            <pre>
              <button type="button" mat-button class="copy" (click)="copyCode(tsCode)">
                <i  class="fa fa-copy"></i>
              </button>
              <cpq-scripting-codemirror #editor [script]="tsScript" [languageType]="tsLanguageType" [lineNumbers]="false" [styleActiveLine]="true"
              [disabled]="true"></cpq-scripting-codemirror>
            </pre>
          </mat-tab>
        </mat-tab-group>
      </div>
    }
  </mat-card-content>
</mat-card>
